/**
 * Service-config default for the New/Active (Quote/Loads) titlebar toggle
 * when both views are enabled
 */
enum DefaultSidebarView {
  Unset = '',
  Quote = 'quote',
  Loads = 'loads',
  New = 'new', // UI label alias for Quote
  Active = 'active', // UI label alias for Loads
}

export default DefaultSidebarView;
